<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body" v-if="order">
      <div class="mb-3">
        <b>{{ message.text }}</b>
      </div>
      <div>
        <div class="mb-4">
          {{ $t('message.bank_transfer.confirm_bank_transfer01') }}
          <div>
            <strong>{{ expireDateTime }}</strong>
          </div>
        </div>
        <div class="mb-4">
          <h3>ยอดที่ต้องชำระ:
            <span class="text-orange">
              {{ order.total_price_with_vat | currency }}
            </span>
          </h3>
        </div>
        <div>
          <img :src="globalState.bankAccountData.image_url" width="160" class="mb-2">
        </div>
        <div>
          {{ $t('message.bank_transfer.account_name') }}: {{ globalState.bankAccountData | multiLangName }}
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <div class="flex-grow-1">
            <div>{{ $t('message.bank_transfer.account') }}: {{ globalState.bankAccountData.account_number }}</div>
          </div>
          <div class="text-right">
            <button class="btn btn-outline-info"
                    @click="isCopied = true"
                    v-clipboard:copy="globalState.bankAccountData.account_number">
              {{ isCopied ? $t('message.button.copied') : $t('message.button.copy') }}
            </button>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <div class="text-remark my-3">
          หลังจากที่คุณทำการโอนเงินแล้ว กรุณาแนบรูปหลักฐานการโอน
        </div>
        <div v-if="!uploadSuccess">
          <vue-dropzone ref="vueDropzone"
                        id="dropzone"
                        class="dropzone-dashed"
                        :options="dropzoneOptions"
                        @vdropzone-sending="vueDropZoneAddParams"
                        @vdropzone-mounted="vueDropZoneMounted"
                        @vdropzone-success="vueDropZoneSuccess"/>
          <div class="text-remark mt-2">
            แนบรูปสลิป png หรือ jpg ขนาดไม่เกิน 5 MB
          </div>
        </div>
        <div class="text-center" v-else>
          <i class="fas fa-check-circle -status-accepted"></i>
          {{ $t('message.bank_transfer.upload_success') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import VueCoreImageUpload from 'vue-core-image-upload'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import moment from 'moment-timezone'

  export default {
    props: {
      message: Object
    },
    components: {
      VueCoreImageUpload,
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        order: null,
        expireDateTime: null,
        uploadSuccess: false,
        isCopied: false,
        dropzoneOptions: {
          acceptedFiles: 'image/*',
          url: 'https://beneat.co',
          thumbnailWidth: 160,
          thumbnailHeight: 160,
          maxFilesize: 5,
          dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.attach_slip_here')}`,
          addRemoveLinks: true,
          autoProcessQueue: true
        }
      }
    },
    computed: {
      ...mapGetters({
        authState: 'auth/getState',
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      vueDropZoneAddParams (file, xhr, formData) {
        formData.append('payment_for', 'normal')
      },
      vueDropZoneMounted () {
        const uploadUrl = `${this.$http.options.root}/orders/${this.order.id}/save-bank-transfer-picture`
        this.$refs.vueDropzone.options.url = uploadUrl
        this.$refs.vueDropzone.setOption('url', uploadUrl)
        const headers = { 'Authorization': `Bearer ${this.authState.token}` }
        this.$refs.vueDropzone.options.headers = headers
        this.$refs.vueDropzone.setOption('headers', headers)
      },
      vueDropZoneSuccess (file, response) {
        if (!response.error) {
          this.uploadSuccess = true
          const message = {
            sender_type: 'user',
            type: 'image',
            label: 'success-bank-transfer',
            imageUrl: response.image_url
          }
          this.$store.commit('chatBooking/ADD_MESSAGE', message)
        }
      }
    },
    mounted () {
      this.order = this.message.data
      const startDate = this.order.order_date
      const endDate = this.order.cleaning_date
      const convertedStartDate = moment(startDate, 'YYYY-MM-DD HH:mm:ss')
      const convertedEndDate = moment(endDate, 'YYYY-MM-DD HH:mm:ss')
      const diffHours = moment.duration(convertedEndDate.diff(convertedStartDate)).asHours()
      const hours = (diffHours <= 3) ? 1 : 2
      this.expireDateTime = moment(this.order.order_date).add(hours, 'hours').format('DD MMM YYYY (HH:mm)')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/ChangePaymentBankTransferMessage.vue